const dateJumpAlertSlice = (set) => ({
  dateJumpAlert: null,
  setDateJumpAlert: (type) => set(() => ({ dateJumpAlert: type })),
  hideDateJumpAlert: () => set({ dateJumpAlert: null }),
})

export default dateJumpAlertSlice
